import { render, staticRenderFns } from "./PedidoTagsForm.vue?vue&type=template&id=3d238a75"
import script from "./PedidoTagsForm.vue?vue&type=script&lang=js"
export * from "./PedidoTagsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports